export default "__VITE_ASSET__C$3uTFgA__"